import * as Sentry from "@sentry/react";

const sampleRate = (raw: string | undefined, fallback: number): number => {
  if (!raw || raw.trim() === "") {
    return fallback;
  }
  const parsed = Number(raw);
  return Number.isFinite(parsed) ? Math.min(1, Math.max(0, parsed)) : fallback;
};

const DSN = import.meta.env.PUBLIC_SENTRY_DSN;
const ENVIRONMENT = import.meta.env.PUBLIC_ENVIRONMENT ?? "development";
const RELEASE = import.meta.env.PUBLIC_SENTRY_RELEASE;
const TRACES_SAMPLE_RATE = sampleRate(
  import.meta.env.PUBLIC_SENTRY_TRACES_SAMPLE_RATE,
  ENVIRONMENT === "production" ? 0.1 : 1.0,
);

let initialized = false;

export function initSentry() {
  if (initialized) {
    return;
  }

  if (!DSN) {
    console.warn("Sentry DSN not configured, skipping initialization");
    return;
  }

  initialized = true;

  Sentry.init({
    dsn: DSN,
    environment: ENVIRONMENT,
    ...(RELEASE ? { release: RELEASE } : {}),
    tracesSampleRate: TRACES_SAMPLE_RATE,
    // Attach sentry-trace/baggage headers to API calls so frontend
    // pageloads link to backend transactions in one trace.
    tracePropagationTargets: ["localhost", /^https:\/\/api-.*\.ryanmac\.dev/],
    replaysSessionSampleRate: ENVIRONMENT === "production" ? 0.1 : 0,
    replaysOnErrorSampleRate: 1.0,
    integrations: [Sentry.browserTracingIntegration(), Sentry.replayIntegration()],
  });
}

export { Sentry };
